import { t } from "i18next"
import { makeEmptyTdTags } from "../../utils"

type Props = {
  burdenMaxMonth: number
  localBurdenMaxMonth: number
}

export function KyotoUpperMonthLimit({
  burdenMaxMonth,
  localBurdenMaxMonth,
}: Props) {
  return (
    <table className={"nbl_info_top_content__table"}>
      <tbody>
        <tr>
          <td className={"large_cell"}>
            {t("Maximum monthly payment by users (country) ①")}
          </td>
          {String(burdenMaxMonth)
            .padStart(6, ".")
            .split("")
            .map((v, indx) => (
              <td key={indx}>{v !== "." ? v : ""}</td>
            ))}
          <td>{t("Maximum monthly payment by users (city) ②")}</td>
          {String(localBurdenMaxMonth)
            .padStart(6, ".")
            .split("")
            .map((v, indx) => (
              <td key={indx}>{v !== "." ? v : ""}</td>
            ))}
        </tr>
        <tr>
          <td colSpan={8}>
            {t(
              "Maximum monthly payment for users of community living support projects ③"
            )}
          </td>
          {makeEmptyTdTags(6)}
        </tr>
      </tbody>
    </table>
  )
}
